type AppInfo = {
  // Stable identifier that never changes when the page is renamed. Kept in
  // kebab-case to match the `AppId` values used for registry apps.
  appId: string
  appName: string
  appPath: string
}

export const getNonAppPageInfo = (pathname: string): AppInfo => {
  if (pathname === '/' || pathname === '') {
    return { appId: 'desktop', appName: 'Desktop', appPath: '/' }
  }

  if (pathname.startsWith('/login')) {
    return { appId: 'login', appName: 'Login', appPath: '/login' }
  }

  if (pathname.startsWith('/register')) {
    return { appId: 'register', appName: 'Register', appPath: '/register' }
  }

  if (pathname === '/2fa-setup') {
    return { appId: '2fa-setup', appName: '2FA', appPath: '/2fa-setup' }
  }

  if (pathname.includes('/public')) {
    return { appId: 'public-page', appName: 'Public Page', appPath: pathname }
  }

  if (pathname.includes('/guest')) {
    return { appId: 'guest-page', appName: 'Guest Page', appPath: pathname }
  }

  return { appId: 'unknown', appName: 'Unknown App', appPath: pathname }
}
